import clone from "lodash/clone";

/**
 * converts a percentage (such as "1.1%") to a decimal (".011")
 * @param {string} percentage
 * @returns
 */
const percentToDec = (percentage = "") => {
  let returnValue = clone(percentage);
  returnValue = returnValue.replace(/%/, "");

  let addAZeroLater = "";
  if (!/\./.test(returnValue)) returnValue = `${returnValue}.`;
  else if (returnValue.slice(-1) === ".") addAZeroLater = "0";

  let index = returnValue.indexOf(".");

  let newIndex = index - 2;
  while (newIndex < 0) {
    returnValue = `0${returnValue}`;
    newIndex++;
    index++;
  }

  const before = returnValue.slice(0, newIndex);
  const after = returnValue.slice(newIndex).replace(".", "");

  returnValue = `${before}.${after}${addAZeroLater}`;

  return returnValue;
};

/**
 * converts a decimal (such as .011) to a percentage (such as 1.1%)
 * @param {string} dec
 * @param {object} options
 * @param {boolean} options.0
 */
const decToPercent = (dec = "") => {
  let returnValue = clone(dec.toString());

  if (!/\./.test(returnValue)) returnValue = `${returnValue}.`;
  let index = returnValue.indexOf(".");

  let newIndex = index + 2;
  while (newIndex > returnValue.length - 1) {
    returnValue = `${returnValue}0`;
  }

  const before = returnValue.replace(".", "").slice(0, newIndex);
  const after = returnValue.replace(".", "").slice(newIndex);

  returnValue = `${before.replace(/^0+/, "")}${after ? "." : ""}${
    after !== "0" ? after : ""
  }`;

  const splitArray = returnValue.split(".");
  if (splitArray.length === 2) {
    returnValue = `${splitArray[0]}.${splitArray[1].slice(0, 1)}`;
  } // limit decimal places to 1

  return `${returnValue}${returnValue ? "%" : ""}`;
};

const percentageRegExp = /^[0-9]*\.?[1-9]*%?$/;

const addLeadingSlash = (probablyAUrl) => {
  const prefixSlash =
    Boolean(probablyAUrl) && !/^\//.test(probablyAUrl) ? "/" : "";
  return `${prefixSlash}${probablyAUrl}`;
};

export { percentToDec, decToPercent, percentageRegExp, addLeadingSlash };
